import React, { useEffect, useMemo, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import supplierService from "../../../../services/supplier_appCommonService";

//API
import DataTable from "react-data-table-component";
// import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import toast from "react-hot-toast";

//Redux
import { useDispatch, useSelector } from "react-redux";
import { formatDate, getTodaysData } from "../../../../common/Validations";
import { getEquipmentRentFormList } from "../../../../redux/feature/customer_app/customerSlice";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

let ewayBillNumberData = [
  {
    id: "1",
    name: "Yes",
    code: "YES",
    description: "Yes",
  },
  {
    id: "2",
    name: "No",
    code: "NO",
    description: "No",
  },
];
let accountsStatusNumberData = [
  {
    id: "1",
    name: "Hold",
    code: "HOL",
    description: "Hold",
  },
  {
    id: "2",
    name: "Cancelled",
    code: "CAN",
    description: "Cancelled",
  },
  {
    id: "3",
    name: "Done",
    code: "DON",
    description: "Done",
  },
  {
    id: "4",
    name: "Pending",
    code: "PEN",
    description: "Pending",
  },
  {
    id: "5",
    name: "Reconciliation",
    code: "REC",
    description: "Reconciliation",
  },
];

const ErfInvoiceModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  let userData = useSelector((state) => state?.user); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };

  // eslint-disable-next-line no-unused-vars
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [lineItemData, setLineItemData] = useState([]);
  const [saleLineItemData, setSaleLineItemData] = useState([]);
  const [nursingItemsData, setNursingItemsData] = useState([]);
  const [serviceLineItemData, setServiceLineItemData] = useState([]);

  const [invoiceData, setInvoiceData] = useState();
  // console.log(">>invoiceData", invoiceData);
  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [totals, setTotals] = useState({
    totalBags: 0,
    totalAmount: 0,
    totalCgst: 0,
    totalSgst: 0,
    totalNetValue: 0,
  });
  const [disable, setDisabled] = useState(false);

  const lineItemCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "From Date",
      selector: (row) => row?.fromDate,
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{formatDate(row?.fromDate)} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "To Date",
      selector: (row) => row?.toDate,
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{formatDate(row?.toDate)} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Rent Slab",
      selector: (row) => row?.rentSlab,
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];

  const saleLineItemCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{formatDate(row?.fromDate)} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];
  const nursingItemsCol = [
    {
      name: "SlNo.",
      cell: (row) => {
        const numberPart = row?.local_id?.split("-")[1];
        const slNo = numberPart !== undefined ? Number(numberPart) + 1 : "--";

        return (
          <div>
            <p className="m-0 p-0">{slNo}</p>
          </div>
        );
      },
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    // {
    //   name: "Barcode",
    //   selector: (row) => row?.barcode,
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{formatDate(row?.fromDate)} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];
  const serviceItemsCol = [
    {
      name: "SlNo.",
      cell: (row) => <p className="m-0 p-0">{row?.equipmentItemNr}</p>,
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription}</p>
          <p className="m-0 p-0">{row?.materialCode}</p>
        </div>
      ),
      width: "150px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity}</p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Date",
      cell: (row) => <span>{formatDate(row?.fromDate)}</span>,
      width: "130px",
    },
    {
      name: "Net Value",
      cell: (row) => <span>{row?.netValue ?? "--"}</span>,
      width: "120px",
    },
    {
      name: "GST(%)",
      cell: (row) => <span>{row?.taxPercentage ?? "--"}</span>,
      width: "100px",
    },
    {
      name: "Tax Amt",
      cell: (row) => <span>{row?.taxAmount ?? "--"}</span>,
      width: "120px",
    },
    {
      name: "Gross Amt",
      cell: (row) => <span>{row?.grossValue ?? "--"}</span>,
      width: "120px",
    },
  ];

  useEffect(() => {
    setInvoiceData((invoiceData) => ({
      ...invoiceData,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);

  // ✅ Initial props load
  // useEffect(() => {
  //   if (props?.invoiceinfo) {
  //     setInvoiceData(props?.invoiceinfo);
  //     const data = props.invoiceinfo;
  //     if (data?.signature) {
  //       loadUploadedFiles(data.signature);
  //     }

  //     // const updatedLineItems = props?.invoiceinfo?.items?.map((item) => {
  //     //   const orderQuantityLoad = parseFloat(item.orderQtyLoadConfirm) || 0;
  //     //   const unitPrice = parseFloat(item.unitPrice) || 0;
  //     //   const reversePercentage = parseFloat(item.reversePercentage) || 1;
  //     //   const cgst = parseFloat(item.cgst) || 0;
  //     //   const sgst = parseFloat(item.sgst) || 0;

  //     //   const basicPrice =
  //     //     Math.round((unitPrice / reversePercentage) * 100) / 100;
  //     //   const basicAmount =
  //     //     Math.round(
  //     //       (unitPrice / reversePercentage) * orderQuantityLoad * 100,
  //     //     ) / 100;

  //     //   const cgstValue = Math.round(((cgst * basicAmount) / 100) * 100) / 100;
  //     //   const sgstValue = Math.round(((sgst * basicAmount) / 100) * 100) / 100;
  //     //   const gstValue = cgstValue + sgstValue;
  //     //   const netValue = (
  //     //     parseFloat(gstValue) + parseFloat(basicAmount)
  //     //   )?.toFixed(2);

  //     //   return {
  //     //     ...item,
  //     //     basicPrice,
  //     //     basicAmount,
  //     //     cgstValue,
  //     //     sgstValue,
  //     //     gstValue,
  //     //     netValue,
  //     //     creditAmount: 0,
  //     //     debitAmount: parseFloat(netValue),
  //     //     isIGST: false,
  //     //     igstPercent: "",
  //     //   };
  //     // });

  //     setLineItemData(props?.invoiceinfo?.rentItems);
  //     setSaleLineItemData(props?.invoiceinfo?.saleItems);
  //     setNursingItemsData(props?.invoiceinfo?.nursingItems);
  //     getCompanyDetails(props?.invoiceinfo?.companyNr);

  //     // calculateTotals(updatedLineItems);
  //   }
  //   // eslint-disable-next-line
  // }, [props?.invoiceinfo]);

  useEffect(() => {
    if (!props?.invoiceinfo) return;

    const data = props.invoiceinfo;

    if (data?.signature) {
      loadUploadedFiles(data.signature);
    }

    // ----- 1. Detect extension record -----
    // Sale items do NOT extend, so an extension document must have saleItems = []
    const isExtension =
      !!data?.equipmentExtNr ||
      (typeof data?.documentNumber === "string" &&
        (data.documentNumber.startsWith("EX") ||
          data.documentNumber.includes("ERFEXT")));

    // ----- 2. Filter out non-billable items -----
    // creditNoteStatus = "CreditNote" (PCD marked) or "StockIn" (Store returned)
    const isBillable = (item) =>
      Number(item?.netValue) !== 0 && !item?.creditNoteStatus;

    const rentItems = (data?.rentItems || []).filter(isBillable);
    const saleItems = isExtension
      ? []
      : (data?.saleItems || []).filter(isBillable);
    const nursingItems = (data?.nursingItems || []).filter(isBillable);
    const serviceItems = (data?.serviceItems || []).filter(isBillable);

    // ----- 3. Recompute totals from filtered items -----
    // pre-credit-note aggregates and will overstate the invoice.
    const sumOf = (items, field) =>
      items.reduce((sum, i) => sum + Number(i?.[field] || 0), 0);

    const round2 = (n) => Number((n || 0).toFixed(2));

    // Rent
    const rentNetTotal = round2(sumOf(rentItems, "netValue"));
    const rentTaxTotal = round2(sumOf(rentItems, "taxAmount"));
    const rentGrossTotal = round2(
      rentNetTotal + rentTaxTotal + Number(data?.rentCartage || 0),
    );

    // Sale
    const saleNetTotal = round2(sumOf(saleItems, "netValue"));
    const saleTaxTotal = round2(sumOf(saleItems, "taxAmount"));
    const saleGrossTotal = round2(
      saleNetTotal + saleTaxTotal + Number(data?.salesCartage || 0),
    );

    // Nursing (cartage field is "cartage")
    const nursingNetTotal = round2(sumOf(nursingItems, "netValue"));
    const nursingTaxTotal = round2(sumOf(nursingItems, "taxAmount"));
    const nursingGrossTotal = round2(
      nursingNetTotal + nursingTaxTotal + Number(data?.cartage || 0),
    );

    // Service (no cartage)
    const serviceNetTotal = round2(sumOf(serviceItems, "netValue"));
    const serviceTaxTotal = round2(sumOf(serviceItems, "taxAmount"));
    const serviceGrossTotal = round2(serviceNetTotal + serviceTaxTotal);

    // ----- 4. Store filtered items + recomputed totals on invoiceData -----
    // handleSave reads from invoiceData, so it will save the correct (filtered) items.
    setInvoiceData({
      ...data,
      rentItems,
      saleItems,
      nursingItems,
      serviceItems,
      rentNetTotal,
      rentTaxTotal,
      rentGrossTotal,
      saleNetTotal,
      saleTaxTotal,
      saleGrossTotal,
      nursingNetTotal,
      nursingTaxTotal,
      nursingGrossTotal,
      serviceNetTotal,
      serviceTaxTotal,
      serviceGrossTotal,
      isExtensionInvoice: isExtension,
    });

    setLineItemData(rentItems);
    setSaleLineItemData(saleItems);
    setNursingItemsData(nursingItems);
    setServiceLineItemData(serviceItems);

    getCompanyDetails(data?.companyNr);
    // eslint-disable-next-line
  }, [props?.invoiceinfo]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  const onInputChange = ({ target: { name, value } }) => {
    setInvoiceData((invoiceData) => ({ ...invoiceData, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const { documentNumber, _id, ...cleanInvoiceData } = invoiceData;

      const mergedItems = [
        ...lineItemData,        // rent (filtered)
        ...saleLineItemData,    // sale (filtered, [] for extension)
        ...nursingItemsData,    // nursing (filtered)
        ...serviceLineItemData, // service (filtered)
      ];

      const itemsWithLocalId = mergedItems.map((item, index) => ({
        ...item,
        local_id: index + 1,
      }));

      const obj = {
        data: {
          ...cleanInvoiceData,
          generatedDate: getTodaysData(),
          postingDate: getTodaysData(),
          transaction: "Sales",
          transactionType: "INV",
          items: itemsWithLocalId,
          // items: lineItemData,
        },
      };

      const payloadData = {
        documentNumber: invoiceData?.documentNumber,
        equipmentNr: invoiceData?.documentNumber,
        signature: invoiceData?.signature,
        typeOfOperation: "Single",
        invoiceCreated: true,
        accountsStatus: invoiceData?.accountsStatus,
        accountsStatusCode: invoiceData?.accountsStatusCode,
        accountsStatusDesc: invoiceData?.accountsStatusDesc,
        creditNoteNumber: invoiceData?.creditNoteNumber,
        accountsRemarks: invoiceData?.accountsRemarks,
        ewayBill: invoiceData?.ewayBill,
        ewayBillCode: invoiceData?.ewayBillCode,
        ewayBillDesc: invoiceData?.ewayBillDesc,
        creditNoteAttachment: invoiceData?.creditNoteAttachment,

        accountsRefundStatus: invoiceData?.accountsRefundStatus,
        accountsRefundStatusCode: invoiceData?.accountsRefundStatusCode,
        accountsRefundStatusDesc: invoiceData?.accountsRefundStatusDesc,
        accountsRefundRemarks: invoiceData?.accountsRefundRemarks,
      };
      const payloadData2 = {
        equipmentRentNr: invoiceData?.equipmentRentNr,
        equipmentExtNr: invoiceData?.equipmentExtNr,
        equipmentNr: invoiceData?.equipmentNr,
        extInvoiceCreated: true,
        invoiceCreated: true,
      };

      setDisabled(true);

      const response = await ItemServiceV2.addInvoice(obj);

      if (response?.status === 200) {
        toast.success(response?.message || "Added successfully", {
          duration: 2000,
          position: "top-right",
        });

        // ✅ Now this will properly wait
        if (invoiceData?.equipmentExtNr) {
          await ItemService.updateExtendEquipmentRent(payloadData2);
        } else {
          await ItemService.updateEquipmentRentForm(payloadData);
        }
        await fetchData();
        props.onHide();
      } else {
        toast.error(response?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };
  const documentTypeMap = {
    "101 - GST Registration": "GST",
    "100 - PAN Registration": "PAN",
    "131 - GST Registration": "GST",
  };
  //get company details
  const [companyDetails, setCompanyDetails] = useState();

  const getCompanyDetails = async (id) => {
    try {
      const obj = {
        queryName: "Get_CompanyMaster_Details",
        documentNumber: id,
      };

      const res = await ItemServiceV2.generateCustomerQuery(obj);

      if (res?.status === 200 && res?.data) {
        const company = res.data?.[0];
        setCompanyDetails(company);

        // 🔹 Main form
        // setFormInputs(company);

        // // 🔹 Contact Persons
        // setcustomerContactPerson(company.contactDetails || []);

        // // 🔹 Documents
        // setDocumentTypeData(company.certifications || []);

        // // 🔹 Bank Details
        // // setBankDetails(company.bankDetails[0] || []);
        // setBankDetailsData(company.bankDetails[0] || []);

        // // 🔹 Company Profile
        // setCompanyProfile(company.companyProfile || {});
      }
    } catch (error) {
      console.error("Failed to load company details", error);
    }
  };
  const isSalesPerson = useMemo(() => {
    return (
      userData?.data?.roles?.some((r) => r.roleId === "SALES-OFFICER") || false
    );
  }, [userData]);
  const isStorePerson = useMemo(() => {
    return userData?.data?.roles?.some((r) => r.roleId === "STORE") || false;
  }, [userData]);
  const fetchData = async (page = 1, size = 10, search = "") => {
    try {
      const payload = {
        queryName: "ERFList",
        page,
        per_page: size,
        searchTerm: search,
        timeZone: "Asia/Calcutta",
        rowFilter: {},
      };

      const payload2 = {
        queryName: "ExtEquipmentList",
        page: page,
        per_page: size,
        searchTerm: search,
        timeZone: "Asia/Calcutta",
      };

      let statusFilter = null;

      if (isSalesPerson) {
        statusFilter = ["In progress", "Approved"];
      } else if (isStorePerson) {
        statusFilter = ["Approved", "Dispatched"];
      }

      if (statusFilter) {
        payload.rowFilter = {
          $and: [{ status: { $in: statusFilter } }],
        };
      }
      if (invoiceData?.equipmentExtNr) {
        await dispatch(getEquipmentRentFormList(payload2));
      } else {
        await dispatch(getEquipmentRentFormList(payload));
      }
    } catch (error) {
      console.error("Error fetching list", error);
      toast.error("Error loading records");
    } finally {
    }
  };
  //file upload signature
  const onSuccessUploadsignatureCard = (data) => {
    // FileUploadComponentForHB returns: { fieldName, attachmentId, id }
    const attachmentId = data?.attachmentId || "";

    if (!attachmentId) {
      toast.error("Upload failed: Missing attachment ID.");
      return;
    }

    // Store attachmentId in state
    setInvoiceData((prev) => ({
      ...prev,
      signature: attachmentId,
    }));
    loadUploadedFiles(attachmentId);

    toast.success("uploaded successfully");
  };

  //file upload creditnote
  const onSuccessUploadCreditNoteCard = (data) => {
    // FileUploadComponentForHB returns: { fieldName, attachmentId, id }
    const attachmentId = data?.attachmentId || "";

    if (!attachmentId) {
      toast.error("Upload failed: Missing attachment ID.");
      return;
    }

    // Store attachmentId in state
    setInvoiceData((prev) => ({
      ...prev,
      creditNoteAttachment: attachmentId,
    }));
    loadUploadedFiles(attachmentId);

    toast.success("uploaded successfully");
  };
  //delet fucution for file upload
  const handleDeletePatientDocument = async (docType) => {
    let documentData = {};
    let successMessage = "";

    if (docType === "signature") {
      documentData = {
        attachmentId: invoiceData.signature,
        fileName: invoiceData?.aadharCardFileName,
      };
      successMessage = "Signature deleted successfully";
    } else if (docType === "creditNoteAttachment") {
      documentData = {
        attachmentId: invoiceData.creditNoteAttachment,
        fileName: invoiceData.creditNoteFileName,
      };
      successMessage = "Credit Note deleted successfully";
    }

    if (!documentData.attachmentId) {
      toast.error("No document to delete");
      return;
    }

    try {
      const response = await ItemService.deleteFile(documentData);

      if (response && response.message) {
        // 🔥 Clear correct state
        setInvoiceData((prev) => {
          if (docType === "signature") {
            return {
              ...prev,
              signature: "",
              aadharCardFileName: "",
            };
          } else if (docType === "creditNoteAttachment") {
            return {
              ...prev,
              creditNoteAttachment: "",
              creditNoteFileName: "",
            };
          }
        });

        toast.success(successMessage);
      } else {
        toast.error("Failed to delete document");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Error deleting document");
    }
  };

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    if (hasFiles && remainingCount === 0) {
      setInvoiceData((prev) => ({
        ...prev,
        signature: "",
        creditNoteAttachment: "",
      }));
    }
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);

  // eslint-disable-next-line
  const [validation, setValidation] = useState({});

  // File viewer
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  const [files, setFiles] = useState();
  // eslint-disable-next-line
  const [status, setStatus] = useState(true);

  const loadUploadedFiles = async (attachmentId) => {
    if (attachmentId) {
      let obj = {
        attachmentId,
      };
      setStatus(true);
      await supplierService.getUploadedFiles(obj).then((item) => {
        // setFiles(item.data[0]);
        setFiles(item?.data?.[item.data.length - 1] || null);
      });
      setStatus(false);
    } else {
      // alert('Please select a file first.');
    }
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Invoice Confirmation - {invoiceData?.documentNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* 01 */}
        <div className="accordion mb-4" id="accordionExample" F>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Invoice Address</span>
                  <span className="subHeaderTitle">Invoice details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Col xs={12} md={12} lg={12} className="px-2">
                        {/* <p className="fw-bold mb-0">Company:</p> */}
                        <p className="text-lg mb-0 fw-bold">
                          {companyDetails?.firstName}
                        </p>
                        <p className="text-lg mb-0">
                          {companyDetails?.address +
                            " " +
                            companyDetails?.address2 +
                            " " +
                            companyDetails?.cityPostalCode}
                        </p>
                        <p className="m-0 p-0">
                          Email:{" "}
                          {companyDetails?.contactDetails[0]?.contactEmail}
                        </p>
                        <p className="m-0 p-0">
                          Contact No:{companyDetails?.mobileNr}, 011-25522552
                          {/* {companyDetails?.contactDetails[0]?.contactNumber} */}
                        </p>
                        <p>
                          GST:{companyDetails?.gstNumebr}
                          {/* {companyDetails?.certifications.map((cert) => (
                            <div key={cert.id}>
                              {cert.documentType ===
                                "101 - GST Registration " && (
                                <p>GST : {cert.documentNumber}</p>
                              )}
                            </div>
                          ))} */}
                        </p>
                      </Col>

                      <Col xs={12} md={12} lg={12} className="px-2">
                        {invoiceData?.items?.length > 0 &&
                          Array.isArray(
                            invoiceData.items[0]?.companyCertifications,
                          ) &&
                          invoiceData.items[0].companyCertifications
                            .filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType?.includes(type),
                              ),
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType;

                              return (
                                <p key={index} className="text-lg mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })}
                      </Col>
                      <Col xs={12} md={12} lg={12}>
                        <Row>
                          <Col xs={12} md={4} lg={4} className="ps-2">
                            <p className="fw-bold mb-0">Billing:</p>
                            <p className="text-lg mb-0">
                              {invoiceData?.billingName}
                            </p>
                            <p className="text-lg mb-0">
                              {invoiceData?.billingAddress}
                            </p>
                            <p className="text-lg mb-0">
                              {invoiceData?.billingState}
                              {invoiceData?.billingPinCode}
                            </p>
                          </Col>
                          <Col xs={6} md={6} lg={6}>
                            <Row>
                              <Col xs={12} md={12} lg={12} className="p-2">
                                <p className="fw-bold mb-0">
                                  Delivery Address:
                                </p>
                                <p className="text-lg mb-0">
                                  {invoiceData?.deliveryAddress}
                                </p>
                                <p className="text-lg mb-0">
                                  {invoiceData?.deliveryState}
                                </p>
                                <p className="text-lg mb-0">
                                  {invoiceData?.deliveryPinCode}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Row>
                        {/* <Col xs={6} md={6} lg={6}>
                          <Row>
                            <Col xs={12} md={12} lg={12} className="p-2">
                              <p className="fw-bold mb-0"> Shipping Address:</p>
                              <p className="text-lg mb-0">
                                {companyDetails?.firstName}
                              </p>
                              <p className="text-lg mb-0">
                                {companyDetails?.address +
                                  " " +
                                  companyDetails?.address2 +
                                  " " +
                                  companyDetails?.cityPostalCode}
                              </p>
                              <p className="m-0 p-0">
                                Email:{" "}
                                {
                                  companyDetails?.contactDetails[0]
                                    ?.contactEmail
                                }
                              </p>
                              <p className="m-0 p-0">
                                Phone No:
                                {
                                  companyDetails?.contactDetails[0]
                                    ?.contactNumber
                                }
                              </p>
                              <p>
                                {companyDetails?.certifications.map((cert) => (
                                  <div key={cert.id}>
                                    {cert.documentType ===
                                      "101 - GST Registration " && (
                                      <p>GST : {cert.documentNumber}</p>
                                    )}
                                  </div>
                                ))}
                              </p>
                            </Col>
                          </Row>
                        </Col> */}
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/* rentItems */}
        {lineItemData.length > 0 && (
          <>
            {/*02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RI</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Rent Items</span>
                      <span className="subHeaderTitle">Rent Items details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <DataTable
                              title=""
                              columns={lineItemCol}
                              data={lineItemData}
                              // progressPending={orderSchedulingData?.status}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              pagination
                              paginationServer
                              // paginationTotalRows={orderSchedulingTable.total}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              // onSelectedRowsChange={handleRowSelect}
                              // selectableRows
                            />
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*03 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RD</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Rent details</span>
                      <span className="subHeaderTitle">Rent details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Amount"
                                name="rentNetTotal"
                                id="rentNetTotal"
                                value={invoiceData?.rentNetTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total GST"
                                name="rentTaxTotal"
                                id="rentTaxTotal"
                                value={invoiceData?.rentTaxTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Gross Amount"
                                name="rentGrossTotal"
                                id="rentGrossTotal"
                                value={invoiceData?.rentGrossTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            {/* <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="e-Way Bill Number"
                              extraLabel=""
                              name="ewayBill"
                              code="ewayBillCode"
                              description="ewayBillDesc"
                              data={ewayBillNumberData}
                              id="ewayBill"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.ewayBill}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={false}
                            />
                          </Col>                
                       </Row> */}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* saleItems */}
        {saleLineItemData.length > 0 && (
          <>
            {/*02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SI</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Sale Items</span>
                      <span className="subHeaderTitle">Sale Items details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <DataTable
                              title=""
                              columns={saleLineItemCol}
                              data={saleLineItemData}
                              // progressPending={orderSchedulingData?.status}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              pagination
                              paginationServer
                              // paginationTotalRows={orderSchedulingTable.total}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              // onSelectedRowsChange={handleRowSelect}
                              // selectableRows
                            />
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*03 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SI</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Sale details</span>
                      <span className="subHeaderTitle">Sale details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Net Total"
                                name="saleNetTotal"
                                id="saleNetTotal"
                                value={invoiceData?.saleNetTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total GST"
                                name="saleTaxTotal"
                                id="saleTaxTotal"
                                value={invoiceData?.saleTaxTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Gross Total"
                                name="saleGrossTotal"
                                id="saleGrossTotal"
                                value={invoiceData?.saleGrossTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* nursingItems */}
        {nursingItemsData.length > 0 && (
          <>
            {/*02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">NI</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Nursing Items</span>
                      <span className="subHeaderTitle">
                        Nursing Items details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <DataTable
                              title=""
                              columns={nursingItemsCol}
                              data={nursingItemsData}
                              // progressPending={orderSchedulingData?.status}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              pagination
                              paginationServer
                              // paginationTotalRows={orderSchedulingTable.total}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              // onSelectedRowsChange={handleRowSelect}
                              // selectableRows
                            />
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*03 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible7
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ND</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Nursing details</span>
                      <span className="subHeaderTitle">Nursing details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible7 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Net Total"
                                name="nursingNetTotal"
                                id="nursingNetTotal"
                                value={invoiceData?.nursingNetTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total GST"
                                name="nursingTaxTotal"
                                id="nursingTaxTotal"
                                value={invoiceData?.nursingTaxTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Gross Amount"
                                name="nursingGrossTotal"
                                id="nursingGrossTotal"
                                value={invoiceData?.nursingGrossTotal}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {serviceLineItemData.length > 0 && (
          <>
            {/* Service Items */}
            <div className="accordion mb-4">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible11 ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility11}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SV</span>
                    </Col>
                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Service Items</span>
                      <span className="subHeaderTitle">
                        Service Items details
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible11 ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <DataTable
                              title=""
                              columns={serviceItemsCol}
                              data={serviceLineItemData}
                              pagination
                              paginationServer
                            />
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Service Totals */}
            <div className="accordion mb-4">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible11 ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility11}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SD</span>
                    </Col>
                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Service details</span>
                      <span className="subHeaderTitle">Service details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible11 ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Net Total"
                                name="serviceNetTotal"
                                value={invoiceData?.serviceNetTotal}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total GST"
                                name="serviceTaxTotal"
                                value={invoiceData?.serviceTaxTotal}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Gross Total"
                                name="serviceGrossTotal"
                                value={invoiceData?.serviceGrossTotal}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible9 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility9}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">IF</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Information to be filled</span>
                  <span className="subHeaderTitle">
                    Information to be filled
                  </span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible9 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Accounts Status"
                            extraLabel=""
                            name="accountsStatus"
                            code="accountsStatusCode"
                            description="accountsStatusDesc"
                            data={accountsStatusNumberData}
                            id="accountsStatus"
                            iconClassName="dropdownIcon"
                            setValue={invoiceData?.accountsStatus}
                            getvalue={setDropdownData}
                            required={true}
                            disabled={invoiceData?.invoiceCreated}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Credit Note Number"
                            name="creditNoteNumber"
                            id="creditNoteNumber"
                            value={invoiceData?.creditNoteNumber}
                            onChange={onInputChange}
                            disabled={invoiceData?.invoiceCreated}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Accounts Remarks"
                            name="accountsRemarks"
                            id="accountsRemarks"
                            value={invoiceData?.accountsRemarks}
                            onChange={onInputChange}
                            disabled={invoiceData?.invoiceCreated}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="e-Way Bill Number"
                            extraLabel=""
                            name="ewayBill"
                            code="ewayBillCode"
                            description="ewayBillDesc"
                            data={ewayBillNumberData}
                            id="ewayBill"
                            iconClassName="dropdownIcon"
                            setValue={invoiceData?.ewayBill}
                            getvalue={setDropdownData}
                            required={true}
                            disabled={invoiceData?.invoiceCreated}
                          />
                        </Col>
                        {!invoiceData?.invoiceCreated && (
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <Row>
                              <Col xs={10} md={10} lg={10}>
                                <FileUploadComponentForHB
                                  id="creditNoteAttachment"
                                  name="creditNoteAttachment"
                                  label="Credit Note"
                                  allowedTypes={["image/png", "image/jpeg"]}
                                  multiple={true}
                                  onSuccessUpload={
                                    onSuccessUploadCreditNoteCard
                                  }
                                  value={
                                    invoiceData?.creditNoteAttachment || ""
                                  }
                                />
                              </Col>

                              <Col
                                xs={2}
                                md={2}
                                lg={2}
                                className="d-flex align-items-center"
                              >
                                {invoiceData?.creditNoteAttachment && (
                                  <>
                                    {/* View Icon */}
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="attachmentIcon me-2"
                                      alt="view"
                                      onClick={() =>
                                        handleViewFile(
                                          invoiceData?.creditNoteAttachment,
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      title="View signature "
                                    />

                                    {/* Delete Icon */}
                                    {/* <i
                                      className="bi bi-trash text-danger fs-5"
                                      onClick={() =>
                                        handleDeletePatientDocument(
                                          "creditNoteAttachment",
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      title="Delete credit Note"
                                    /> */}
                                  </>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        )}
                        {invoiceData?.invoiceCreated && (
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <Row>
                              <Col
                                xs={2}
                                md={2}
                                lg={2}
                                className="d-flex align-items-center"
                              >
                                {invoiceData?.creditNoteAttachment && (
                                  <>
                                    {/* View Icon */}
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="attachmentIcon me-2"
                                      alt="view"
                                      onClick={() =>
                                        handleViewFile(
                                          invoiceData?.creditNoteAttachment,
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      title="View signature "
                                    />
                                  </>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility10}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">IF</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">
                    Refund Information to be filled
                  </span>
                  <span className="subHeaderTitle">
                    Refund Information to be filled
                  </span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible10 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Refund Status"
                            extraLabel=""
                            name="accountsRefundStatus"
                            code="accountsRefundStatusCode"
                            description="accountsRefundStatusDesc"
                            data={accountsStatusNumberData}
                            id="accountsRefundStatus"
                            iconClassName="dropdownIcon"
                            setValue={invoiceData?.accountsRefundStatus}
                            getvalue={setDropdownData}
                            required={true}
                            disabled={invoiceData?.invoiceCreated}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Remarks"
                            name="accountsRefundRemarks"
                            id="accountsRefundRemarks"
                            value={invoiceData?.accountsRefundRemarks}
                            onChange={onInputChange}
                            disabled={invoiceData?.invoiceCreated}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {false && (
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible8 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility8}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">US</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Uplaod Sign</span>
                    <span className="subHeaderTitle">Uplaod Sign</span>
                  </Col>
                </Row>
              </h2>

              <div
                // id="acc"
                className={`accordion-collapse collapse show ${
                  isCardVisible8 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {!invoiceData?.invoiceCreated && (
                            <Col
                              xs={12}
                              md={10}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                <Col xs={10} md={10} lg={10}>
                                  <FileUploadComponentForHB
                                    id="signature"
                                    name="signature"
                                    label="Upload signature Card"
                                    allowedTypes={["image/png", "image/jpeg"]}
                                    multiple={true}
                                    onSuccessUpload={
                                      onSuccessUploadsignatureCard
                                    }
                                    value={invoiceData?.signature || ""}
                                  />
                                </Col>

                                <Col
                                  xs={2}
                                  md={2}
                                  lg={2}
                                  className="d-flex align-items-center"
                                >
                                  {invoiceData?.signature && (
                                    <>
                                      {/* View Icon */}
                                      <img
                                        src="assets/img/newIcons/attached-file.png"
                                        className="attachmentIcon me-2"
                                        alt="view"
                                        onClick={() =>
                                          handleViewFile(invoiceData?.signature)
                                        }
                                        style={{ cursor: "pointer" }}
                                        title="View signature "
                                      />

                                      {/* Delete Icon */}
                                      <i
                                        className="bi bi-trash text-danger fs-5"
                                        onClick={() =>
                                          handleDeletePatientDocument(
                                            "signature",
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                        title="Delete signature "
                                      />
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          )}
                          {invoiceData?.signature && (
                            <Col
                              sm={12}
                              md={2}
                              lg={4}
                              className="commTopButtonRightLeftPadding d-flex justify-content-start"
                            >
                              <img
                                src={files?.Location}
                                alt="signature"
                                className="img-fluid"
                                style={{
                                  width: "200px",
                                  height: "120px",
                                  objectFit: "contain",
                                  border: "1px solid black",
                                  borderRadius: "4px",
                                }}
                              />
                            </Col>
                          )}
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}

        {!invoiceData?.invoiceCreated && !viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end mt-2"
            >
              <button className="btnTable btn-danger" onClick={handleCancel}>
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mt-2">
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disable}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
        {/* for test */}
        {/* <Col lg={2} className="d-flex justify-content-end mt-2">
          <button className="btnTable" onClick={handleSave} disabled={disable}>
            Save
          </button>
        </Col> */}
        <FileViewerModalForHB
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
          onDeleteSuccess={handleAttachmentDeleted}
          showDelete={!invoiceData?.invoiceCreated}
        />
        <FailureModal
          show={getShowFailureModal}
          onHide={() => hideFailureModal()}
          failuremodaldata={getFailureModal}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default ErfInvoiceModal;
